import type { TicketDTO } from "../types/dtos";
import type { ColumnConfig } from "@repo/types/ui/tables";

export const TicketColumns = {
  id: {
    key: "Id",
    label: "Ticket Id",
  },
  title: {
    key: "Title",
    label: "Ticket",
  },
  channel: {
    key: "EntityId",
    label: "Channel",
  },
  assignee: {
    key: "AssignedToId",
    label: "Assignee",
  },
  status: {
    key: "StatusKeyValuePairId",
    label: "Status",
  },
  priority: {
    key: "PriorityKeyValuePairId",
    label: "Priority",
  },
  description: {
    key: "Description",
    label: "Description",
  },
  attachments: {
    key: "Attachments",
    label: "Attachments",
  },
  updatedOn: {
    key: "UpdatedOn",
    label: "Last Updated On",
  },
  createdOn: {
    key: "CreatedOn",
    label: "Created On",
  },
} satisfies Record<string, ColumnConfig<TicketDTO>>;

